<template>
    <div v-if="showBanner && cookiesAcceptedByUser" class="app-banner">
      <p>📲 Hol dir auch unsere <template v-if="isIOS">iOS</template><template v-else>Android</template> App! 🎉</p>
      <div class="app-buttons">
        <a
          v-if="isIOS"
          href="https://apps.apple.com/de/app/foodi-de/id6449926467"
          target="_blank"
          class="app-button apple"
        >
          iOS App herunterladen
        </a>
        <a
          v-else-if="isAndroid"
          href="https://play.google.com/store/apps/details?id=app.foodi.de&hl=de"
          target="_blank"
          class="app-button android"
        >
          Android App herunterladen
        </a>
      </div>
      <button @click="closeBanner" class="close-button">✖️</button>
    </div>
  </template>
  
  <script>
  export default {
    name: "AppBanner",
    data() {
      return {
        showBanner: false,
        isIOS: false,
        isAndroid: false,
      };
    },

    computed: {
      cookiesAcceptedByUser: () => {
        return window.cookiesAcceptedByUser
      }
    },

    watch: {
      $route(to) {
        this.updateBannerVisibility(to.name);
      },
    },

    mounted() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const hasSeenBanner = localStorage.getItem("appBannerClosed");
  
      if (!hasSeenBanner) {
        if (/iPhone|iPad|iPod/i.test(userAgent)) {
          this.isIOS = true;
          this.showBanner = true;
        } else if (/Android/i.test(userAgent)) {
          this.isAndroid = true;
          this.showBanner = true;
        }
      }
    },

    methods: {
      closeBanner() {
        this.showBanner = false;
        localStorage.setItem("appBannerClosed", "true");
      },

      updateBannerVisibility(path) {
        if (path === "Shop" || path === "Generator") {
          this.showBanner = false;
        } else {
          const hasSeenBanner = localStorage.getItem("appBannerClosed");
          this.showBanner = !hasSeenBanner && (this.isIOS || this.isAndroid);
        }
      }
    },
  };
  </script>
  
  <style scoped>
  .app-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #f8f9fa;
    border-top: 1px solid #ddd;
    text-align: center;
    padding: 10px 20px;
    z-index: 9999;
    font-family: Arial, sans-serif;
  }
  .app-buttons {
    margin-top: 10px;
  }
  .app-button {
    margin: 5px;
    padding: 5px 10px;
    border-radius: 5px;
    text-decoration: none;
    font-size: 14px;
  }
  .app-button.apple {
    background-color: #000;
    color: #fff;
  }
  .app-button.android {
    background-color: #000;
    color: #fff;
  }
  .close-button {
    position: absolute;
    top: 5px;
    right: 10px;
    border: none;
    background: none;
    font-size: 16px;
    cursor: pointer;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/AppBanner.vue